var _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFilePptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2435_61343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48715 36.8457V7.28125H6.20312V40.1297H30.9201V36.8457H9.48715Z",
    fill: "#F4F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2435_61343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48438 4V36.8485H34.2014V11.5193L26.6821 4H9.48438Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.199 11.5193L26.6797 4V11.5193H34.199Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 19H15.8753C16.2038 19 16.4855 19.0645 16.7201 19.1877C16.9548 19.311 17.1367 19.487 17.2599 19.7099C17.3831 19.9329 17.4418 20.191 17.4418 20.4785C17.4418 20.766 17.3772 21.03 17.254 21.2529C17.1308 21.4759 16.9431 21.646 16.7084 21.7692C16.4679 21.8924 16.1862 21.9511 15.8518 21.9511H15.0656V23.3768H14.1562V19ZM15.7051 21.2236C15.9692 21.2236 16.1686 21.1591 16.3036 21.0241C16.4385 20.8892 16.5089 20.7073 16.5089 20.4785C16.5089 20.2497 16.4385 20.0737 16.3036 19.9446C16.1686 19.8155 15.9692 19.751 15.7051 19.751H15.0656V21.2295H15.7051V21.2236Z",
    fill: "#82868C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0156 19H19.7347C20.0632 19 20.3448 19.0645 20.5795 19.1877C20.8142 19.311 20.9961 19.487 21.1193 19.7099C21.2425 19.9329 21.3012 20.191 21.3012 20.4785C21.3012 20.766 21.2366 21.03 21.1134 21.2529C20.9902 21.4759 20.8025 21.646 20.5678 21.7692C20.3272 21.8924 20.0456 21.9511 19.7112 21.9511H18.925V23.3768H18.0156V19ZM19.5645 21.2236C19.8285 21.2236 20.028 21.1591 20.163 21.0241C20.2979 20.8892 20.3683 20.7073 20.3683 20.4785C20.3683 20.2497 20.2979 20.0737 20.163 19.9446C20.028 19.8155 19.8285 19.751 19.5645 19.751H18.925V21.2295H19.5645V21.2236Z",
    fill: "#82868C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.709 19H25.2937V19.751H23.9502V23.3827H23.0467V19.751H21.7031V19H21.709Z",
    fill: "#82868C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5943 20.5078H27.6237L28.5272 19H29.5539L28.2162 21.1884L29.5833 23.3768H28.5331L27.6237 21.869H27.5943L26.685 23.3768H25.6406L27.0135 21.1884L25.6641 19H26.6967L27.5943 20.5078Z",
    fill: "#82868C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2435_61343",
    x: 2.20312,
    y: 3.28125,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2435_61343",
    x: 5.48438,
    y: 0,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61343",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFilePptx);
export default __webpack_public_path__ + "static/media/i_file_pptx.0b7efa3c9a1fbb90bcbe50b4cc1a1203.svg";
export { ForwardRef as ReactComponent };